import { isNumber } from '@/helpers/common';

export default {
  validate (claimAmount) {
    return {
      required: true,
      valid: Number(claimAmount) >= Number(this.constants.CLAIM_AMOUNT_MIN) && Number(claimAmount) <= Number(this.constants.CLAIM_AMOUNT_MAX),
    };
  },
  message (fieldName, { _value_: claimAmount }) {
    if (!claimAmount && !isNumber(claimAmount)) return 'Please enter an amount.';
    return `Please enter a number between ${this.constants.CLAIM_AMOUNT_MIN} and ${this.constants.CLAIM_AMOUNT_MAX}.`;
  },
  computesRequired: true,
};
